<template>
    <div v-if="showWhatsAppFloat" :class="containerClasses">
        <a
            :href="`https://wa.me/${supportPhone}`"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
            :title="`Conversar no WhatsApp: ${formatPhone(supportPhone)}`"
        >
            <font-awesome-icon
                :icon="['fab', 'whatsapp']"
                class="text-white text-2xl"
            />
        </a>
    </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { usePage } from "@inertiajs/vue3";

const props = defineProps({
    product: {
        type: Object,
        default: () => ({}),
    },
    fieldConfigs: {
        type: Object,
        default: () => ({}),
    },
    isPreview: {
        type: Boolean,
        default: false,
    },
});

// Verificar se deve exibir o ícone flutuante
const showWhatsAppFloat = computed(() => {
    // Verificar se fieldConfigs existe e tem a propriedade showWhatsAppFloat
    if (!props.fieldConfigs || typeof props.fieldConfigs !== "object") {
        return false;
    }

    // Verificar se showWhatsAppFloat é explicitamente true
    return props.fieldConfigs.showWhatsAppFloat === true;
});

// Classes do container baseadas no estado de preview
const containerClasses = computed(() => {
    if (props.isPreview) {
        return "absolute bottom-6 right-6 z-50";
    }

    return "fixed bottom-6 right-6 z-50";
});

// Obter telefone de suporte do produto
const supportPhone = computed(() => {
    return props.product?.producer_phone || usePage().props.supportWhatsAppE164;
});

// Função para formatar telefone
const formatPhone = (phone) => {
    if (!phone) return "";

    // Remove todos os caracteres não numéricos
    const cleanPhone = phone.replace(/\D/g, "");

    // Se começar com 55, remove
    if (cleanPhone.startsWith("55")) {
        const withoutCountry = cleanPhone.substring(2);
        return `+55 (${withoutCountry.substring(
            0,
            2
        )}) ${withoutCountry.substring(2, 7)}-${withoutCountry.substring(7)}`;
    }

    // Se não começar com 55, adiciona
    if (cleanPhone.length === 11) {
        return `+55 (${cleanPhone.substring(0, 2)}) ${cleanPhone.substring(
            2,
            7
        )}-${cleanPhone.substring(7)}`;
    }

    return phone;
};
</script>
